import { Component, Input } from '@angular/core';
import { Document } from 'src/app/models/document';

@Component({
    selector: 'app-file-uploader',
    templateUrl: './file-uploader.component.html',
    styleUrls: ['./file-uploader.component.scss']
})
export class FileUploaderComponent {
    @Input() previewMode: boolean = false;
    @Input() editMode: boolean = false;
    @Input() selectedFiles: File[] = [];
    @Input() previousFiles: Document[] = [];
    @Input() title: string;
    @Input() subTitles: string[] = [];
    @Input() onFileSelected: (files: FileList) => void;
    @Input() removeFile: (indx: number) => void;
    @Input() removePreviousFile: (indx: number) => void;
    @Input() acceptedFormats: string;
    @Input() maxFileSize: number = 1 * 1024 * 1024;
    @Input() hasExceededMaxFileSize: boolean = false;
    @Input() documentsSizes = 0;

    constructor() {}

    /** The limit as a whole number of MB, for the "exceeds the limit" message. */
    get maxFileSizeMb(): number {
        return Math.round(this.maxFileSize / (1024 * 1024));
    }

    removeAlert() {
        this.hasExceededMaxFileSize = false;
    }
}
